import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./ExternalDashboardTableStyle";
import ExternalDashboard from "components/external/externalDashboard";

const DashboardTable = React.memo((props) => {
  return (
    <>
      <ExternalDashboard />

    </>
  );
});

export default withRouter(DashboardTable);
